module.exports = __webpack_public_path__ + "eu.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/eu.svg
// module id = 1156
// module chunks = 0